export const ADD_MOOD = 'ADD_MOOD'
export const SET_MOODS = 'SET_MOODS'
export const SET_METER_NEED = 'SET_METER_NEED'